import { useState } from "react";
import {
  useCreateEventMutation,
  useDeleteEventMutation,
  useGetAdminEventsQuery,
} from "../../features/api/appApi";
import AdminSectionCard, {
  AdminButton,
  AdminEmptyState,
  AdminField,
  AdminFormGrid,
  AdminInput,
  AdminScrollTable,
  AdminSelect,
  AdminStatusBadge,
} from "./AdminSectionCard";

const defaultEventForm = {
  title: "",
  date: "",
  type: "workshop",
  status: "upcoming",
  bgImageLink: "",
};

const AdminEventsPage = () => {
  const { data: events = [] } = useGetAdminEventsQuery();
  const [createEvent] = useCreateEventMutation();
  const [deleteEvent] = useDeleteEventMutation();

  const [eventForm, setEventForm] = useState(defaultEventForm);

  return (
    <AdminSectionCard title="Events" subtitle="Create and manage event cards">
      <form
        className="space-y-3"
        onSubmit={async (e) => {
          e.preventDefault();
          await createEvent(eventForm);
          setEventForm(defaultEventForm);
        }}
      >
        <AdminFormGrid>
          <AdminField label="Title">
            <AdminInput
              placeholder="Title"
              value={eventForm.title}
              onChange={(e) => setEventForm({ ...eventForm, title: e.target.value })}
              required
            />
          </AdminField>

          <AdminField label="Date">
            <AdminInput
              type="date"
              value={eventForm.date}
              onChange={(e) => setEventForm({ ...eventForm, date: e.target.value })}
              required
            />
          </AdminField>

          <AdminField label="Type">
            <AdminSelect
              value={eventForm.type}
              onChange={(e) => setEventForm({ ...eventForm, type: e.target.value })}
            >
              <option value="workshop">Workshop</option>
              <option value="contest">Contest</option>
              <option value="orientation">Orientation</option>
              <option value="ceremony">Ceremony</option>
              <option value="exam">Exam</option>
              <option value="other">Other</option>
            </AdminSelect>
          </AdminField>

          <AdminField label="Status">
            <AdminSelect
              value={eventForm.status}
              onChange={(e) => setEventForm({ ...eventForm, status: e.target.value })}
            >
              <option value="upcoming">Upcoming</option>
              <option value="past">Past</option>
            </AdminSelect>
          </AdminField>

          <AdminField label="Background image URL" className="md:col-span-2">
            <AdminInput
              placeholder="Background image URL"
              value={eventForm.bgImageLink}
              onChange={(e) => setEventForm({ ...eventForm, bgImageLink: e.target.value })}
            />
          </AdminField>
        </AdminFormGrid>

        <AdminButton className="w-full md:w-auto" type="submit">
          Create Event
        </AdminButton>
      </form>

      <div className="mt-5">
        {events.length ? (
          <AdminScrollTable>
            <table className="w-full min-w-[720px] text-left text-sm">
              <thead className="bg-slate-50 text-xs uppercase tracking-wide text-slate-500">
                <tr>
                  <th className="px-4 py-3">Title</th>
                  <th className="px-4 py-3">Date</th>
                  <th className="px-4 py-3">Type</th>
                  <th className="px-4 py-3">Status</th>
                  <th className="px-4 py-3 text-right">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {events.map((event) => (
                  <tr key={event.id} className="bg-white hover:bg-slate-50/70">
                    <td className="max-w-[320px] break-words px-4 py-3 font-semibold text-slate-800">
                      {event.title}
                    </td>
                    <td className="px-4 py-3 text-slate-600">
                      {new Date(event.date).toLocaleDateString()}
                    </td>
                    <td className="px-4 py-3 text-slate-600">{event.type || "-"}</td>
                    <td className="px-4 py-3">
                      <AdminStatusBadge tone={event.status === "upcoming" ? "blue" : "green"}>
                        {event.status || "N/A"}
                      </AdminStatusBadge>
                    </td>
                    <td className="px-4 py-3 text-right">
                      <AdminButton
                        variant="danger"
                        className="h-9 px-3 text-xs"
                        onClick={() => deleteEvent(event.id)}
                      >
                        Delete
                      </AdminButton>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </AdminScrollTable>
        ) : (
          <AdminEmptyState text="No events available yet." />
        )}
      </div>
    </AdminSectionCard>
  );
};

export default AdminEventsPage;
